import { useEffect, useState } from "react";
import { addWard, getAllWards, toggleDesignationStatus, toggleWardsStatus, updateWard } from "../../services/AdminServices";
import WardList from "../../components/AdminComponents/PagesComponents/Ward/WardList";
import AddWardModal from "../../components/AdminComponents/PagesComponents/Ward/AddWardModal";
import MessageModal from "../../components/AdminComponents/Modals/MessageModal";
import ConfirmActionModal from "../../components/AdminComponents/Modals/ConfirmActionModal";

const AdminWardsPage = () => {
    const [openModal, setOpenModal] = useState(false);
    const [editData, setEditData] = useState(null);

    const [wards, setWards] = useState([]);
    const [loading, setLoading] = useState(false);

    const [confirmModal, setConfirmModal] = useState({
        open: false,
        ward: null,
    });

    const [messageModal, setMessageModal] = useState({
        open: false,
        type: "success",
        title: "",
        message: "",
    });

    const showSuccess = (msg) => {
        setMessageModal({
            open: true,
            type: "success",
            title: "Success",
            message: msg,
        });
    };

    const showError = (msg) => {
        setMessageModal({
            open: true,
            type: "error",
            title: "Error",
            message: msg,
        });
    };

    const handleToggleRequest = (ward) => {
        setConfirmModal({ open: true, ward });
    };

    const handleConfirmToggle = async () => {
        try {
            await toggleWardsStatus(confirmModal.ward.id);
            await loadWards();
            showSuccess(confirmModal.ward.active ? "Ward deactivated successfully" : "Ward activated successfully");
        } catch (err) {
            showError(err?.response?.data?.message || "Something went wrong");
        } finally {
            setConfirmModal({ open: false, ward: null });
        }
    };

    const loadWards = async () => {
        try {
            setLoading(true);
            const res = await getAllWards();
            if (res.success) {
                setWards(res.data);
            }
        } catch (err) {
            console.error(err?.response?.data?.message);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadWards();
    }, [])

    const handleSave = async (formData) => {
        try {
            console.log(formData);
            let res;
            if (editData) {
                res = await updateWard(editData.id, formData);
            } else {
                res = await addWard(formData);
            }

            if (res.success) {
                await loadWards();
                setOpenModal(false);
                setEditData(null);
                showSuccess(res.message);
            }
        } catch (err) {
            showError(err?.response?.data?.message || "Something went wrong");
        }
    };

    return (
        <div className="p-4 admin-card-box space-y-4">
            <div className="flex justify-between items-center">
                <h2 className="admin-heading text-blue">Wards</h2>
                <button
                    className="btnAdd"
                    onClick={() => {
                        setEditData(null);
                        setOpenModal(true);
                    }}
                >
                    + Add Ward
                </button>
            </div>

            <WardList
                data={wards}
                loading={loading}
                onEdit={(d) => {
                    setEditData(d);
                    setOpenModal(true);
                }}
                onToggle={handleToggleRequest}
            />

            <AddWardModal
                open={openModal}
                editData={editData}
                onClose={() => setOpenModal(false)}
                onSave={handleSave}
            />


            <ConfirmActionModal
                open={confirmModal.open}
                title={
                    confirmModal.ward?.active
                        ? "Deactivate Designation"
                        : "Activate Designation"
                }
                message={
                    confirmModal.ward?.active
                        ? "Do you really want to deactivate this designation?"
                        : "Do you want to activate this designation again?"
                }
                confirmText={
                    confirmModal.ward?.active ? "DEACTIVATE" : "ACTIVATE"
                }
                onConfirm={handleConfirmToggle}
                onClose={() =>
                    setConfirmModal({ open: false, ward: null })
                }
            />

            <MessageModal
                open={messageModal.open}
                type={messageModal.type}
                title={messageModal.title}
                message={messageModal.message}
                onClose={() =>
                    setMessageModal({ ...messageModal, open: false })
                }
            />
        </div>
    )
}

export default AdminWardsPage;